module.exports = __webpack_public_path__ + "../resources/img/Web_Image_Grid.f793ea00.svg";